module.exports = __webpack_public_path__ + "static/media/S (152).107b7375.jpg";